import {
  APPLICATION_IDS,
  TOOL_IDS,
  TRIBUNALEA_APPLICATION_IDS,
  TRIBUNALEA_TOOL_IDS,
  applicationIdForTool,
} from "./access-catalog.js";

export const ACTIVITY_ACTIONS = Object.freeze({
  PORTAL_OPENED: "portal_opened",
  APP_OPENED: "app_opened",
  TOOL_OPENED: "tool_opened",
  TOOL_USED: "tool_used",
  CREDIT_PURCHASED: "credit_purchased",
  CREDIT_USED: "credit_used",
});

export const ACTIVITY_ACTION_IDS = Object.freeze(
  Object.values(ACTIVITY_ACTIONS),
);

export const ACTIVITY_OPEN_ACTION_IDS = Object.freeze([
  ACTIVITY_ACTIONS.PORTAL_OPENED,
  ACTIVITY_ACTIONS.APP_OPENED,
  ACTIVITY_ACTIONS.TOOL_OPENED,
]);

export const ACTIVITY_APPLICATION_IDS = Object.freeze({
  ...APPLICATION_IDS,
  ACCOUNT: "account",
  ASTREA: "astrea",
});

export const ACTIVITY_APPLICATION_ID_VALUES = Object.freeze([
  ...TRIBUNALEA_APPLICATION_IDS,
  ACTIVITY_APPLICATION_IDS.ACCOUNT,
  ACTIVITY_APPLICATION_IDS.ASTREA,
]);

export const ACTIVITY_TOOL_IDS = Object.freeze({
  ...TOOL_IDS,
  ACCOUNT_CREDITS: "account:credits",
  ACCOUNT_SIGNATURE: "account:signature",
  ACCOUNT_ORGANIZATION: "account:organization",
  ASTREA_LIBRARY: "astrea:library",
  ASTREA_ASSISTANT: "astrea:assistant",
});

export const ACTIVITY_TOOL_ID_VALUES = Object.freeze([
  ...TRIBUNALEA_TOOL_IDS,
  ACTIVITY_TOOL_IDS.ACCOUNT_CREDITS,
  ACTIVITY_TOOL_IDS.ACCOUNT_SIGNATURE,
  ACTIVITY_TOOL_IDS.ACCOUNT_ORGANIZATION,
  ACTIVITY_TOOL_IDS.ASTREA_LIBRARY,
  ACTIVITY_TOOL_IDS.ASTREA_ASSISTANT,
]);

const ACTIVITY_ONLY_TOOL_APPLICATIONS = Object.freeze({
  [ACTIVITY_TOOL_IDS.ACCOUNT_CREDITS]: ACTIVITY_APPLICATION_IDS.ACCOUNT,
  [ACTIVITY_TOOL_IDS.ACCOUNT_SIGNATURE]: ACTIVITY_APPLICATION_IDS.ACCOUNT,
  [ACTIVITY_TOOL_IDS.ACCOUNT_ORGANIZATION]: ACTIVITY_APPLICATION_IDS.ACCOUNT,
  [ACTIVITY_TOOL_IDS.ASTREA_LIBRARY]: ACTIVITY_APPLICATION_IDS.ASTREA,
  [ACTIVITY_TOOL_IDS.ASTREA_ASSISTANT]: ACTIVITY_APPLICATION_IDS.ASTREA,
});

export function activityApplicationIdForTool(toolId) {
  return applicationIdForTool(toolId)
    || ACTIVITY_ONLY_TOOL_APPLICATIONS[toolId]
    || null;
}

export const ACTIVITY_STEPS = Object.freeze({
  EXPEDIENTE_SEARCH_SUBMITTED: "expediente_search_submitted",
  EXPEDIENTE_OPENED: "expediente_opened",
  EXPEDIENTE_ADDED: "expediente_added",
  EXPEDIENTE_REFRESHED: "expediente_refreshed",
  EXPEDIENTE_ARCHIVED: "expediente_archived",
  EXPEDIENTE_RESTORED: "expediente_restored",
  EXPEDIENTE_REMOVED: "expediente_removed",
  EXPEDIENTE_DOCUMENT_OPENED: "expediente_document_opened",
  FOLLOW_UP_ADDED: "follow_up_added",
  FOLLOW_UP_REMOVED: "follow_up_removed",
  WORKFLOW_TEMPLATE_CREATED: "workflow_template_created",
  WORKFLOW_TEMPLATE_UPDATED: "workflow_template_updated",
  WORKFLOW_TEMPLATE_ARCHIVED: "workflow_template_archived",
  WORKFLOW_RECORD_CREATED: "workflow_record_created",
  WORKFLOW_RECORD_UPDATED: "workflow_record_updated",
  WORKFLOW_SMART_VALUE_RESOLVED: "workflow_smart_value_resolved",
  REMINDER_CREATED: "reminder_created",
  REMINDER_UPDATED: "reminder_updated",
  REMINDER_REMOVED: "reminder_removed",
  DAILY_LIST_SEARCHED: "daily_list_searched",
  ALERT_CREATED: "alert_created",
  ALERT_UPDATED: "alert_updated",
  ALERT_REMOVED: "alert_removed",
  WRITING_CREATED: "writing_created",
  WRITING_UPDATED: "writing_updated",
  WRITING_REMOVED: "writing_removed",
  WRITING_CONTEXT_PREPARED: "writing_context_prepared",
  WRITING_SUGGESTED: "writing_suggested",
  WRITING_AI_EDITED: "writing_ai_edited",
  LEGAL_SEARCH_SUBMITTED: "legal_search_submitted",
  LEGAL_RESOURCE_OPENED: "legal_resource_opened",
  SENTENCE_SEARCH_SUBMITTED: "sentence_search_submitted",
  SENTENCE_DOCUMENT_OPENED: "sentence_document_opened",
  DOCUMENT_PROCESSING_REQUESTED: "document_processing_requested",
  DOCUMENT_PROCESSING_REVIEWED: "document_processing_reviewed",
  DOCUMENT_PROCESSING_APPROVED: "document_processing_approved",
  DOCUMENT_OUTPUT_GENERATED: "document_output_generated",
  INTEREST_DRAFT_CREATED: "interest_draft_created",
  INTEREST_SENTENCES_ANALYZED: "interest_sentences_analyzed",
  INTEREST_CALCULATED: "interest_calculated",
  LIBRARY_NOTEBOOK_CREATED: "library_notebook_created",
  LIBRARY_SOURCE_ADDED: "library_source_added",
  ASSISTANT_MESSAGE_SENT: "assistant_message_sent",
  CIVITA_RESOURCE_CREATED: "civita_resource_created",
  CIVITA_ANALYSIS_REQUESTED: "civita_analysis_requested",
  CIVITA_OUTPUT_GENERATED: "civita_output_generated",
  CIVITA_CASE_SEARCHED: "civita_case_searched",
});
